export default __webpack_public_path__ + "SAs_headersDISC.html";